export const MENTION_USER_CHARACTER = '@';
export const MENTION_PROJECT_CHARACTER = '#';

export const CHARACTER_MENTION_TRIGGER_LIST = [
  MENTION_USER_CHARACTER,
  MENTION_PROJECT_CHARACTER,
];

export const TEXT_MEASUREMENT = {
  MAX_VISIBLE_LINES: 4,
  MAX_VISIBLE_LINES_MOBILE: 3,
  MAX_VISIBLE_HEIGHT: 100, // Max height in px for expandable content (desktop)
  MAX_VISIBLE_HEIGHT_MOBILE: 75, // Max height in px for expandable content (mobile)
  BROWSER_HEIGHT_TOLERANCE: 5, // Small tolerance for browser rendering
  OFFSCREEN_POSITION: '-9999px', // Position element outside viewport for measurement
};

export const TEXT_RENDERING_PROPERTIES = [
  'fontFamily',
  'fontSize',
  'lineHeight',
  'fontWeight',
  'letterSpacing',
  'padding',
] as const;

export const INVALID_VALUE = 'NaN';
